const SortArrowIcon = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24.009 24.009"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="m21.075 10.194-8.702-8.703c-.206-.205-.54-.205-.745 0l-8.702 8.703c-.246.244-.379.573-.379.914s.133.67.38.914l.121.107c.514.398 1.244.352 1.704-.108l5.958-5.96-.002 15.311c0 .713.579 1.292 1.292 1.292l.15-.009c.651-.076 1.142-.628 1.142-1.283v-15.31s5.956 5.958 5.956 5.958c.505.505 1.322.505 1.827 0s.505-1.322 0-1.827z"
    />
  </svg>
)

export default SortArrowIcon